"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chemkitFeatureFlags = exports.CHEMOTION_USER_ID_HEADER = exports.CHEMKIT_CLIENT_ID_HEADER = exports.CHEMKIT_PRESENCE_CLIENT_ID_STORAGE_KEY = void 0;
exports.CHEMKIT_PRESENCE_CLIENT_ID_STORAGE_KEY = "chemkit.presence.client_id";
exports.CHEMKIT_CLIENT_ID_HEADER = "x-chemkit-client-id";
exports.CHEMOTION_USER_ID_HEADER = "x-chemotion-user-id";
/**
 * Chemkit feature flags. The object reference is stable; individual flag
 * properties are mutable so test files can flip them temporarily for
 * assertions about enabled-state behavior. Production code never mutates
 * these.
 */
exports.chemkitFeatureFlags = {
    /**
     * Presence / heartbeat feature. Disabled by default under the
     * open-tab scope rule (ADR 0010): synthetic stale notifications are
     * emitted only for entities in the receiving client's open-tab
     * scope, so the cross-request presence store that the heartbeat
     * fed is not needed.
     *
     * To re-enable, set this to `true` and rebuild chemkit. The heartbeat
     * sender, route, and subsample split protective loop will all resume
     * (their call sites are gated on this flag).
     */
    presence: false,
};
